import { Badge, Icon, LinkButton } from '@/components/ui';
import { paths } from '@/routes/paths';

/**
 * Opens the applications received for one internship, best fit first, and says
 * when new ones are waiting there.
 */
export function ViewApplicationsButton({ internship }) {
  const count = internship.new_applications_count ?? 0;
  return (
    <LinkButton
      to={paths.company.internshipApplications(internship.id)}
      variant="tintBrand"
      size="sm"
      title={`Applications for ${internship.title}`}
    >
      <Icon name="users" size={14} />
      View Applications
      {count > 0 && <Badge tone="success">{count} new</Badge>}
    </LinkButton>
  );
}
